module.exports = __webpack_public_path__ + "static/media/Cristo.21762428.png";